import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2020/App/E4/";

export const app2020 = [
    {
        'numInvitacion' : 'APP-913005997-E4-2020',
        'procedimiento' : [
            {
                'numProc' : 'Concurso Público No. APP-913005997-E4-2020',
                'vigenciaProc' : 'Fecha límite para adquirir las Bases Generales del Concurso: 29 de mayo de 2020',
                'descripcionProc' : 'Proyecto de Asociación Público Privada, para la prestación del servicio de disponibilidad de la "Carretera Real del Monte - Entronque Huasca", en el Estado de Hidalgo, así como el otorgamiento de una concesión de jurisdicción estatal por 30 años para la Construcción, Operación, Explotación, Conservación y Mantenimiento de la "Carretera Real del Monte - Entronque Huasca", en el Estado de Hidalgo.',
                'urlDictamen' : `${ ligabase }DE4.PDF`,
                'urlAnexos' : `${ ligabase }AppE4.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Presentación para Taller Informativo',
                        'urlResultado' : `${ ligabase }PTIE4.pdf`,
                    },
                    {
                        'resultado' : 'Taller de Información',
                        'urlResultado' : `${ ligabase }TIE4.pdf`,
                    },
                    {
                        'resultado' : 'Acta Circunstanciada de la visita al sitio',
                        'urlResultado' : `${ ligabase }ACVSE4.pdf`,
                    },
                    {
                        'resultado' : 'Aviso',
                        'urlResultado' : `${ ligabase }AE4.pdf`,
                    },
                    {
                        'resultado' : 'Primera Junta de Aclaraciones y Anexos',
                        'urlResultado' : `${ ligabase }JAE4.rar`,
                    },
                    {
                        'resultado' : 'Segunda Junta de Aclaraciones y Anexos',
                        'urlResultado' : `${ ligabase }2JAE4.rar`,
                    },
                    {
                        'resultado' : 'Versión PDF segunda junta de aclaraciones',
                        'urlResultado' : `${ ligabase }JAPDFE4.rar`,
                    },
                    {
                        'resultado' : 'Notificación',
                        'urlResultado' : `${ ligabase }NTE4.pdf`,
                    },
                    {
                        'resultado' : 'Acta de firma de planos',
                        'urlResultado' : `${ ligabase }AFPE4.pdf`,
                    },
                    {
                        'resultado' : 'Planos firmados 1 de 2',
                        'urlResultado' : `${ ligabase }PF1E4.pdf`,
                    },
                    {
                        'resultado' : 'Planos firmados 2 de 2',
                        'urlResultado' : `${ ligabase }PF2E4.pdf`,
                    },
                    {
                        'resultado' : 'Notificación 2',
                        'urlResultado' : `${ ligabase }NT2E4.pdf`,
                    },
                    {
                        'resultado' : 'Presentación de propuestas y apertura de ofertas técnicas',
                        'urlResultado' : `${ ligabase }APE4.pdf`,
                    },
                    {
                        'resultado' : 'Notificación 3',
                        'urlResultado' : `${ ligabase }NT3E4.pdf`,
                    },
                    {
                        'resultado' : 'Resultado de evaluación de Ofertas Técnicas y Apertura de las Ofertas Económicas',
                        'urlResultado' : `${ ligabase }REE4.pdf`,
                    },
                ]
            }
        ]
    }
]